export const ROOT_ROUTE = '/taxonomymapper';

export const CONFIG = [
	{
		path: `${ROOT_ROUTE}/direct`,
		name: 'direct',
		label: 'Direct Spend',
	},
	{
		path: `${ROOT_ROUTE}/indirect`,
		name: 'indirect',
		label: 'Indirect Spend',
	},
];
